let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lF9NR")).then(() => parcelRequire('c0TOy'));